import { render, staticRenderFns } from "./ModalVoidPayslip.vue?vue&type=template&id=2d6ca0a1"
import script from "./ModalVoidPayslip.vue?vue&type=script&lang=js"
export * from "./ModalVoidPayslip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6ca0a1')) {
      api.createRecord('2d6ca0a1', component.options)
    } else {
      api.reload('2d6ca0a1', component.options)
    }
    module.hot.accept("./ModalVoidPayslip.vue?vue&type=template&id=2d6ca0a1", function () {
      api.rerender('2d6ca0a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payslips/ModalVoidPayslip.vue"
export default component.exports